import {createSlice} from '@reduxjs/toolkit';

interface PolicyRowState {
	actions: [];
	conditions: [];
	transformations: [];
}

const initialState: PolicyRowState = {
	actions: [],
	conditions: [],
	transformations: [],
};

const policyRowSlice = createSlice({
	name: 'policyRow',
	initialState,
	reducers: {
		setPolicyRow: (state, action) => {
			state.actions = action.payload.actions;
			state.conditions = action.payload.conditions;
			state.transformations = action.payload.transformations;
		},
	},
});

export const {setPolicyRow} = policyRowSlice.actions;

export default policyRowSlice.reducer;
